import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MyBookingStoreService } from '@common/services/my-booking/my-booking-store.service';
import { ArrivalDepartureNoticeInformationService } from '@common/services/my-booking/passenger-information-input-modal/arrival-departure-notice-information.service';
import { DuringStayInformationService } from '@common/services/my-booking/passenger-information-input-modal/during-stay-information.service';
import { ImmigrationInformationService } from '@common/services/my-booking/passenger-information-input-modal/immigration-information.service';
import { PassengerInformationInputModalStoreService } from '@common/services/my-booking/passenger-information-input-modal/passenger-information-input-modal-store.service';
import { PassengerInformationInputModalCommonService } from '@common/services/my-booking/passenger-information-input-modal/passenger-information-input-modal.common.service';
import { PassengerInformationInputModalService } from '@common/services/my-booking/passenger-information-input-modal/passenger-information-input-modal.service';
import { PassengerInformationService } from '@common/services/my-booking/passenger-information-input-modal/passenger-information.service';
import { RepresentativeInformationService } from '@common/services/my-booking/passenger-information-input-modal/representative-information.service';
import { SpecialAssistanceRequestModalService } from '@common/services/my-booking/passenger-information-input-modal/special-assistance-request-modal.service';
import { SupportInformationService } from '@common/services/my-booking/passenger-information-input-modal/support-information.service';
import { UpgradeNotificationEmailService } from '@common/services/my-booking/passenger-information-input-modal/upgrade-notification-email.service';
import {
  AlertAreaModule,
  ButtonModule,
  InputModule,
  RadiobuttonBoxModule,
  SelectDateYmdModule,
  SelectModule,
  TextTooltipModule,
} from '@lib/components';
import { StaticMsgModule, StaticMsgPipe } from '@lib/pipes';
import {
  AswServiceStoreService,
  CommonLibModule,
  DialogDisplayServiceModule,
  GetBasicReservationInformationStoreService,
  ModalServiceModule,
} from '@lib/services';
import { AswMasterStoreModule, GetBasicReservationInformationStoreModule } from '@lib/store';
import { PassengerInformationInputModalFooterComponent } from './passenger-information-input-modal-footer.component';
import { PassengerInformationInputModalHeaderComponent } from './passenger-information-input-modal-header.component';
import { PassengerInformationInputModalComponent } from './passenger-information-input-modal.component';
import { DuringStayInformationComponent } from './sub-components/during-stay-information/during-stay-information.component';
import { PassengerInformationModule } from './sub-components/passenger-information/passenger-information.module';
import { RepresentativeInformationComponent } from './sub-components/representative-information/representative-information.component';
import { SpecialAssistanceRequestModalModule } from './sub-components/special-assistance-request-modal/special-assistance-request-modal.module';
import { UpgradeNotificationEmailComponent } from './sub-components/upgrade-notification-email/upgrade-notification-email.component';

@NgModule({
  declarations: [
    PassengerInformationInputModalComponent,
    PassengerInformationInputModalHeaderComponent,
    PassengerInformationInputModalFooterComponent,
    DuringStayInformationComponent,
    RepresentativeInformationComponent,
    UpgradeNotificationEmailComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    GetBasicReservationInformationStoreModule,
    AswMasterStoreModule,

    StaticMsgModule,
    CommonLibModule,
    ModalServiceModule,
    DialogDisplayServiceModule,

    // #region 部品
    AlertAreaModule,
    SelectDateYmdModule,
    ButtonModule,
    InputModule,
    SelectModule,
    TextTooltipModule,
    RadiobuttonBoxModule,
    // #endregion 部品

    // #region サブコンポーネント
    PassengerInformationModule,
    SpecialAssistanceRequestModalModule,
    // #endregion サブコンポーネント
  ],
  providers: [
    StaticMsgPipe,
    AswServiceStoreService,
    GetBasicReservationInformationStoreService,
    MyBookingStoreService,
    PassengerInformationInputModalStoreService,
    PassengerInformationInputModalCommonService,
    PassengerInformationInputModalService,
    RepresentativeInformationService,
    UpgradeNotificationEmailService,
    DuringStayInformationService,
    PassengerInformationService,
    SupportInformationService,
    SpecialAssistanceRequestModalService,
    ArrivalDepartureNoticeInformationService,
    ImmigrationInformationService,
  ],
})
export class PassengerInformationInputModalModule {}
